import React, { useState, useEffect } from 'react'
import { createRoom } from '../../actions/userActions'
import { ReactComponent as CloseIcon } from '../../img/ic_cerrar.svg';
import { seeListChatCategories } from '../../admin/actions/categoriesActions'
import { connect } from 'react-redux'
import { UseComponentVisible2 } from '../../containers/UseComponentVisible2'
import { searchFriends } from '../../actions/searchActions'
import circle from '../../assets/img/plusCircle.png'
import rooms from '../../assets/img/rooms.png'
import { UseComponentVisible } from '../../containers/UseComponentVisible'
import inMemoryJWT from '../../auth/inMemoryJwt';
import Button from '../../utils/components/Button/Button';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateRoom = ({ history, seeListChatCategories, isLoadingListChatCategories, listChatCategories, createRoom }) => {

  
    const [nameRoom,] = useState('')
    const [categorieSearch, setCategorieSearch] = useState('')
    const [categorie, setCategorie] = useState(null)
    const [rules] = useState('')
    const [description] = useState('test')
    const [privacy, ] = useState('')
    const [amountOfParticipants, ] = useState('')
    const [, setValidate] = useState(false)
    const [dataFile, setDataFile] = useState(null)
    const [, setCategorieID] = useState('')


    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Requerido'),
        rules: Yup.string().required('Requerido'),

        privacy: Yup.number().required('Requerido'),
        amountOfParticipants: Yup.number().required('Requerido'),
        categorieID: Yup.string().required('Requerido')

    });
    const formik = useFormik({
        validationSchema,
        isInitialValid: false,
        initialValues: {
            name: "",
            rules: "",
            description: "",
            privacy: "",
            amountOfParticipants: "",
            categorieID: ""
        },
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append('files', values.files)
            console.log()
            formData.append('name', values.name)

            formData.append('chatCategoriesID', values.categorieID)
            formData.append('privacity', values.privacy)
            formData.append('description', values.description)
            formData.append('rules', values.rules)
            formData.append('numberOfMembers', values.amountOfParticipants)

            createRoom(formData, history)
        }
    })
    console.log()

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListChatCategories()
        })

    }, [])


    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = UseComponentVisible(false);



    useEffect(() => {
        if (nameRoom === '' || description === '' || rules === '' || privacy === '' || amountOfParticipants === '' || dataFile === null) {
            setValidate(false)
        }

        if (nameRoom !== '' && description !== '' && rules !== '' && privacy !== '' && amountOfParticipants !== '' && dataFile !== null) {
            setValidate(true)
        }
    }, [dataFile])

    const {
        ref2,
        isComponentVisible2,
        setIsComponentVisible2
    } = UseComponentVisible2(false);








    const onFileChange = (event) => {
        var filesTarget = event.target.files[0]
        filesTarget.url = URL.createObjectURL(event.target.files[0])
        setDataFile(filesTarget)
        formik.setFieldValue("files", filesTarget)
   

    }



    return (
        <div className="relative">
            <div className='showCase-title-container'>
                <div className='showCase-icon-container'>
                    <img src={rooms} height="25" width="25" />
                </div>
                <div className="showCase-title">Crea tu sala de chat</div>

            </div>
            <div className="container-room-create">

                <label className="picture-room-create ">
                    <input type="file" onChange={(event) => {
                        if (event.target.files[0] && event.target.files[0].type.includes('image')) {
                            onFileChange(event)
                        }
                    }} accept="image/*" />
                    {dataFile && dataFile.url && <img className="img-create-room " src={dataFile.url}></img>}
                    {!dataFile && <img className="img-create-room " src={circle}></img>}
                </label>

                <div className="xcontainer-professional-information-create">
                    <div className="container-room-create_form">
                        <div style={{
                            gridArea: "a"
                        }}>
                            <input
                                className='input-room-create mb-2'
                                name="name"
                                value={formik.values.name}
                                type="text"
                                placeholder='Nombre de la sala'
                                onChange={formik.handleChange}

                            />
                            <div className="text-error">{formik.errors.name}</div>
                        </div>
                        <div style={{
                            gridArea: "b"
                        }}>
                            <div className="parent-width relative" ref={ref2}>
                                <div
                                    className="parent-width"
                                    onClick={() =>
                                        setIsComponentVisible2(true)
                                    }
                                >
                                    <div name="categorie" className='input-room-create'>
                                        {categorie ?
                                            <>
                                                {categorie}
                                                <div onClick={(e) => {
                                                    e.stopPropagation();
                                                    setCategorie(null)
                                                }} className="close-select-input">
                                                    <CloseIcon className="cls-1" height="10" width="10" />
                                                </div>
                                            </>
                                            :
                                            'Categoria'
                                        }

                                    </div>
                                    <div className="text-error">{formik.errors.categorieID}</div>
                                </div>
                                {isComponentVisible2 &&
                                    <div className='scroll-menu modal-search-bar-economic-activities'>
                                        <input
                                            autoComplete="off"
                                            className='input-room-create select-search-input'
                                            name="categorieSearch"
                                            type="text"
                                            value={categorieSearch}
                                            placeholder='Buscar'
                                            onChange={(e) => {
                                                setCategorieSearch(e.target.value)
                                            }}
                                        />
                                        <div className="modal-results-search-bar">
                                            <div>
                                                {!isLoadingListChatCategories &&
                                                    <>
                                                        {listChatCategories.filter(category => category.name.toUpperCase().includes(categorieSearch.toUpperCase())).map(category =>
                                                            <div onClick={() => {
                                                                setCategorie(category.name)
                                                                setCategorieID(category._id)
                                                                formik.setFieldValue("categorieID", category._id)
                                                                setIsComponentVisible2(false)
                                                            }} className="mb-2">
                                                                {category.name}
                                                            </div>
                                                        )}
                                                        {listChatCategories.filter(category => category.name.toUpperCase().includes(categorieSearch.toUpperCase())).length === 0 &&
                                                            <div className="">{'No hay resultados'}</div>
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div style={{
                            gridArea: "c"
                        }}>
                            <textarea
                                className='scroll-menu input-rules-room'
                                rows="4"
                                value={formik.values.rules}
                                onChange={formik.handleChange}
                                name="rules"
                                type="text"
                                placeholder='Normas de la sala' />
                            <div className="text-error">{formik.errors.rules}</div>
                        </div>
                        {/* <div style={{
                            gridArea: "a"
                        }}>
                            <input
                                className='input-room-create mb-2'
                                name="description"
                                value={description}
                                type="text"
                                placeholder='Descripción'
                                onChange={e => setDescription(e.target.value.trimStart())}
                                onBlur={e => isEmpty(e)}
                                onFocus={e => isFocused(e)}
                                onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                onMouseOut={e => setDescription(e.target.value.trim())}
                            />
                            <div className="text-error">{error.description}</div>
                        </div> */}

                        <div style={{
                            gridArea: "d"
                        }}>
                            <select value={formik.values.privacy} className='input-room-create input-room-select mb-2' name="privacy" id="privacy" onChange={formik.handleChange}>
                                <option value="" selected disabled hidden>Privacidad</option>
                                <option value='0'>Publico</option>
                                <option value='1'>Privado</option>
                            </select>
                            <div className="text-error">{formik.errors.privacy}</div>
                        </div>

                        <div style={{
                            gridArea: "e"
                        }}>
                            <input
                                className='input-room-create mb-2'
                                name="amountOfParticipants"
                                value={formik.values.amountOfParticipants}
                                min='1'
                                type="number"
                                placeholder='Numero de participantes'
                                onChange={formik.handleChange}


                            />
                            <div className="text-error">{formik.errors.amountOfParticipants}</div>

                        </div>



                    </div>





                </div>
                {/*     <div className='mt-3 mb-3'>Invita a tus amigos</div>
                <div className="search-invite-room">
                    <div ref={ref}>
                        <div
                            className="modal-content-button-search-bar"
                            onClick={() =>
                                setIsComponentVisible(true)
                            }
                        >
                            <div className="search-bar-tag-friend">
                                <img src={searchIcon} alt="img" className="img-search-bar" />
                                <input className="input-inside-div" onFocus={(e) => { searchFriends(e.target.value) }} onChange={(e) => { searchFriends(e.target.value) }} type="text" placeholder="Buscar..." />
                            </div>
                        </div>
                        {isComponentVisible &&
                            <div className='scroll-menu modal-search-bar'>
                                <div className="modal-results-search-bar">
                                    <div>
                                        {isLoading ? <div></div> :
                                            searchList.map((user) => (
                                                !inviteFriend[user._id] &&
                                                <div
                                                    className="column centerItems"
                                                    key={user._id}
                                                    onClick={() => {
                                                        setIsComponentVisible(false)
                                                        setInviteFriend(prevState => { return { ...prevState, [user._id]: user } })
                                                    }} >
                                                    {user.profilePicture ? <img alt="img" onError={(e) => e.target.src = circle} className="picture-search-bar m-1" src={user.profilePicture}></img> :
                                                        <img alt="img" className="picture-search-bar m-1" src={circle}></img>
                                                    }
                                                    {user.name}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                </div>
                <div className='wrapper-2 parent-width'>
                    {Object.values(inviteFriend).length > 0 ?
                        Object.values(inviteFriend).map(friend =>
                            <div className="relative">
                                <div style={{ width: '80%' }}>
                                    <CardImgRankingName data={friend} name={friend.name} url={friend.profilePicture} /></div>
                                <div onClick={() =>
                                    deleteFriendTag(friend._id)
                                } className="delete-invite-friends-icon ml-2">
                                    <CloseIcon className="cls-1" height="18" width="18" />
                                </div>
                            </div>
                        )
                        :
                        <div>

                        </div>}
                </div> */}
                <div className="btns-room">
                    <Button
                        theme='white'
                        text='Guardar'
                        type='submit'
                        disabled={!formik.isValid}
                     
                        onClick={formik.handleSubmit} />
                    {/*   <button onClick={() => history.go(-1)} className='btn btn-inactive p-2'>
                        Cancelar
                    </button>
                    <div className="ml-2 mr-2"></div>
                    <button
                        disabled={isValidate && categorie ? '' : 'disabled'}
                        className={isValidate && categorie ? "btn btn-purple p-2" : "btn btn-purple p-2 btn-inactive"}
                        onClick={() => { saveRoom() }}

                    > {Translate('continue', 'es')}</button> */}
                </div>
            </div>

        </div>


    )
}
const mapStateToProps = (state) => {
    return {
        isLoadingListChatCategories: state.socialCategoriesAdmin.isLoadingListChatCategories,
        listChatCategories: state.socialCategoriesAdmin.listChatCategories,
        searchList: state.users.friendSearchList,
        isLoading: state.users.isLoadingSearchFriendList
    }
}


export default connect(mapStateToProps, { seeListChatCategories, createRoom, searchFriends })(CreateRoom)
